import { styled } from '@mui/material/styles';

/** 48px square choice in a picker grid; the selected one is ringed and its icon brand-colored. */
export const SelectableTile = styled('div', {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 48,
  height: 48,
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  border: selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
  backgroundColor: selected ? theme.palette.action.selected : 'transparent',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: selected ? theme.palette.action.selected : theme.palette.action.hover,
    borderColor: selected ? theme.palette.primary.main : theme.palette.divider,
  },
  '& > .MuiIcon-root, & > .MuiSvgIcon-root': {
    fontSize: 28,
    color: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  },
}));
